import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicContentItem } from '../../interfaces/dynamic-marketing-content';

@Component({
  selector: 'app-dynamic-numbered-card',
  templateUrl: './dynamic-numbered-content.html',
  styleUrls: ['./dynamic-numbered-content.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class DynamicNumberedContentComponent {
  @Input() items?: DynamicContentItem[];

  formatTitle(title: string): { first: string; rest: string; single: boolean } {
    if (!title) return { first: '', rest: '', single: false };

    const trimmed = title.trim();
    const firstSpaceIndex = trimmed.indexOf(' ');

    if (firstSpaceIndex === -1) {
      return { first: '', rest: trimmed, single: true };
    } else {
      const first = trimmed.slice(0, firstSpaceIndex);
      const rest = ' ' + trimmed.slice(firstSpaceIndex + 1);
      return { first, rest, single: false };
    }
  }

  getFormattedLines(content?: string): { first: string; second: string }[] {
    if (!content) return [];
    return content
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length)
      .map(line => {
        const parts = line.split(/–|:/);
        return {
          first: parts[0]?.trim() || '',
          second: parts[1]?.trim().replace(/,$/, '') || ''
        };
      });
  }
}
